<template>
  <div class="w-full">
    <div class="grid grid-cols-12 gap-4 my-3">
      <div class="col-span-12 md:col-span-3">
        <div 
          class="flex justify-between bg-white shadow-md hover:shadow-lg rounded p-4 items-center hover:text-white hover:bg-blue-400 duration-300"
          @mouseenter="cardHover = 'classroom'"
          @mouseleave="cardHover = ''"
        >
          <div
            class="flex items-center justify-center flex-shrink-0 h-12 w-12 rounded-xl bg-blue-100 text-blue-500"
          >
            <svg
              class="w-10 h-10"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                d="M10.394 2.08a1 1 0 00-.788 0l-7 3a1 1 0 000 1.84L5.25 8.051a.999.999 0 01.356-.257l4-1.714a1 1 0 11.788 1.838L7.667 9.088l1.94.831a1 1 0 00.787 0l7-3a1 1 0 000-1.838l-7-3zM3.31 9.397L5 10.12v4.102a8.969 8.969 0 00-1.05-.174 1 1 0 01-.89-.89 11.115 11.115 0 01.25-3.762zM9.3 16.573A9.026 9.026 0 007 14.935v-3.957l1.818.78a3 3 0 002.364 0l5.508-2.361a11.026 11.026 0 01.25 3.762 1 1 0 01-.89.89 8.968 8.968 0 00-5.35 2.524 1 1 0 01-1.4 0zM6 18a1 1 0 001-1v-2.065a8.935 8.935 0 00-2-.712V17a1 1 0 001 1z"
              />
            </svg>
          </div>
          <div class="flex flex-col flex-grow ml-4">
            <div 
              class="text-sm font-medium duration-300"
              :class="cardHover == 'classroom' ? 'text-white' : 'text-gray-600' "
            >
              Total Kelas
            </div>
            <div class="font-bold text-lg">
              {{ classroomsPagination.total }}
            </div>
          </div>
        </div>
      </div>
      <div class="col-span-12 md:col-span-3">
        <router-link
          to="/classroom/free"
          class="flex justify-between bg-white shadow-md hover:shadow-lg rounded p-4 items-center hover:text-white hover:bg-yellow-400 duration-300"
          @mouseenter="cardHover = 'free'"
          @mouseleave="cardHover = ''"
        >
          <div class="flex flex-row ">
            <div
              class="flex items-center justify-center flex-shrink-0 h-12 w-12 rounded-xl duration-300"
              :class="cardHover == 'free' ? 'bg-yellow-100 text-yellow-500' : 'bg-yellow-100 text-yellow-500'"
            >
              <i class="fab fa-earlybirds fa-2x"></i>
            </div>
            <div class="flex flex-col flex-grow ml-4">
              <div 
                class="text-sm font-medium duration-300"
                :class="cardHover == 'free' ? 'text-white' : 'text-gray-600' "
              >Kelas Gratis</div>
              <div class="font-bold text-lg">
                {{ classroomFreeList?.length }}
              </div>
            </div>
          </div>
          <i class="fas fa-arrow-right ml-1"></i>
        </router-link>
      </div>
      <div class="col-span-12 md:col-span-3">
        <router-link
          to="/classroom/hot"
          class="flex justify-between bg-white shadow-md rounded p-4 items-center hover:text-white hover:bg-red-400 duration-300"
          @mouseenter="cardHover = 'hot'"
          @mouseleave="cardHover = ''"
        >
          <div class="flex flex-row ">
            <div
              class="flex items-center justify-center flex-shrink-0 h-12 w-12 rounded-xl duration-300"
              :class="cardHover == 'hot' ? 'bg-red-100 text-red-500' : 'bg-red-100 text-red-500'"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-10 w-10"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z"
                />
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9.879 16.121A3 3 0 1012.015 11L11 14H9c0 .768.293 1.536.879 2.121z"
                />
              </svg>
            </div>
            <div class="flex flex-col flex-grow ml-4">
              <div 
                class="text-sm font-medium"
                :class="cardHover == 'hot' ? 'text-white' : 'text-gray-600' "
              >
                Kelas Hot
              </div>
              <div class="font-bold text-lg">
                {{ hotList?.classrooms?.length }}
              </div>
            </div>
          </div>
          <i class="fas fa-arrow-right ml-1"></i>
        </router-link>
      </div>
      <div class="col-span-12 md:col-span-3">
        <router-link
          to="/classroom/category"
          class="flex justify-between bg-white shadow-md rounded p-4 items-center hover:text-white hover:bg-green-400 duration-300"
          @mouseenter="cardHover = 'category'"
          @mouseleave="cardHover = ''"
        >
          <div class="flex flex-row ">
            <div
              class="flex items-center justify-center flex-shrink-0 h-12 w-12 rounded-xl duration-300"
              :class="cardHover == 'category' ? 'bg-green-100 text-green-500' : 'bg-green-100 text-green-500'"
            >
              <svg
                class="w-10 h-10"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  d="M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM14 11a1 1 0 011 1v1h1a1 1 0 110 2h-1v1a1 1 0 11-2 0v-1h-1a1 1 0 110-2h1v-1a1 1 0 011-1z"
                />
              </svg>
            </div>
            <div class="flex flex-col flex-grow ml-4">
              <div 
                class="text-sm font-medium"
                :class="cardHover == 'category' ? 'text-white' : 'text-gray-600' "            
              >
                Kategori
              </div>
              <div class="font-bold text-lg">{{ categoryList?.length }}</div>
            </div>
          </div>
          <i class="fas fa-arrow-right ml-1"></i>
        </router-link>
      </div>
    </div>

    <DataTable
      :first="query.from"
      :value="classroomsList"
      :paginator="true"
      :rows="query.perPage"
      dataKey="id"
      filterDisplay="menu"
      :loading="isLoadingClassrooms"
      @page="onPage($event)"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[10, 25, 50]"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      responsiveLayout="scroll"
      :totalRecords="classroomsPagination.total"
      :lazy="true"
      showGridlines
      class="p-datatable-sm font-sans text-sm"
      :rowClass="rowClass"
    >
      <template #header>
        <div class="flex flex-col md:flex-row items-start md:items-center justify-between">
          <h5 class="flex-shrink-0 p-m-0 text-lg">List Kelas</h5>
          <div class="w-full flex-grow flex flex-col md:flex-row justify-end md:space-x-4 space-y-2 md:space-y-0">
            <span class="p-input-icon-left">
              <i class="pi pi-search" />
              <InputText
                v-model="query.search"
                @keyup.enter="debounceSearch"
                placeholder="Cari Kelas"
                class="font-sans text-sm w-full"
              />
            </span>
            <router-link
              :to="'/classroom/add'"
              type="button"
              class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 text-base font-medium text-white bg-green-500 hover:bg-green-600 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:w-auto sm:text-sm"
            >
              <i class="fas fa-plus mr-2 self-center"></i>
              Tambah Kelas
            </router-link>

            <div class="flex flex-col justify-center">
              <div class="flex pb-1 items-center">
                <div class="bg-green-100 border border-green-500 w-3 h-3 mr-1 rounded-sm"></div>
                <p class="text-xs font-medium">Kelas Aktif</p>
              </div>
              <div class="flex items-center">
                <div class="bg-red-100 border border-red-500 w-3 h-3 mr-1 rounded-sm"></div>
                <p class="text-xs font-medium">Kelas Tidak Aktif</p>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template #empty>
        <div class="text-center">
          <span class="text-base">No Data found.</span>
        </div>
      </template>
      <template #loading>
        <div class="text-center">
          <span class="text-base">Loading classroom data. Please wait.</span>
        </div>
      </template>
      <Column field="id" header="ID" bodyClass=""></Column>
      <Column field="name" header="Nama Kelas (Kode Kelas)">
        <template #body="{data}"> {{ data.name }} ({{ data.code }}) </template>
      </Column>
      <Column header="Tanggal dibuat" bodyClass="w-52">
        <template #body="{data}">
          {{ formatDate(data.created_at) }}
        </template>
      </Column>
      <Column field="subscribers" header="Peserta" bodyClass="w-20"></Column>
      <Column field="id" header="Aksi" headerClass="w-36" bodyClass="space-x-2 w-36">
        <template #body="{data}">
          <router-link
            :to="'/classroom/' + data.id + '/detail'"
            type="button"
            class="w-full inline-flex items-center justify-center rounded-md border border-transparent shadow-sm hover:shadow-lg p-2 bg-blue-500 text-base font-medium text-white hover:bg-blue-700  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-700 sm:w-auto sm:text-sm duration-300"
            v-tooltip.top="'Lihat Kelas'"
          >
            <i class="fas fa-eye w-4 h-4"></i>
          </router-link>
          <router-link
            :to="'/classroom/' + data.id + '/edit'"
            type="button"
            class="w-full inline-flex items-center justify-center rounded-md border border-transparent shadow-sm hover:shadow-lg p-2 bg-yellow-500 text-base font-medium text-white hover:bg-yellow-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-700 sm:w-auto sm:text-sm duration-300"
            v-tooltip.top="'Edit Kelas'"
          >
            <i class="fas fa-edit w-4 h-4"></i>
          </router-link>
          <router-link
            :to="'/classroom/' + data.id + '/participants'"
            type="button"
            class="w-full inline-flex items-center justify-center rounded-md border border-transparent shadow-sm hover:shadow-lg p-2 bg-purple-600 text-base font-medium text-white hover:bg-purple-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-700 sm:w-auto sm:text-sm duration-300"
            v-tooltip.top="'Peserta'"
          >
            <i class="fas fa-users w-4 h-4"></i>
          </router-link>
        </template>
      </Column>
    </DataTable>
  </div>
</template>
<script>
/* eslint-disable */
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
      loading: false,
      classroom: {},
      classroomId: 0,
      subjects: [],
      items: [],
      currentPage: 1,
      total: 0,
      form: 0,
      to: 0,
      offset: 10,
      search: "",
      perPage: 25,
      page: 1,
      query: {
        search: "",
        perPage: 10,
        page: 1,
        from: 0,
      },
      cardHover: '',
    };
  },
  created() {
    if (this.categoryList?.length == 0) {
      this.fetchAllCategories();
    }
    if (this.classroomsList?.length == 0) {
      this.fetchAllClassrooms(this.query);
      this.query.page = this.classroomsPagination.page;
      this.query.total = this.classroomsPagination.total;
      if (!this.isSuccessClassroom) {
        this.$toast.add({
          severity: "error",
          summary: "Failed",
          detail: this.messageClassroom,
        });
      }
    } else {
      this.query.page = this.classroomsPagination.page;
      this.query.perPage = this.classroomsPagination.per_page;
      this.query.from = this.classroomsPagination.from;
      this.query.total = this.classroomsPagination.total;
    }
    if (this.classroomFreeList?.length == 0) {
      this.fetchClassroomsFreeList();
    }
    if (!this.hotList?.classrooms?.length) {
      this.fetchAllHots();
    }
  },
  computed: {
    ...mapGetters([
      "categoryList",
      "classroomsList",
      "classroomsPagination",
      "isSuccessClassrooms",
      "isLoadingClassrooms",
      "messageClassrooms",
      "classroomFreeList",
      "hotList",
    ]),
  },
  methods: {
    rowClass(data) {
      return data.is_active ? 'active-row duration-300': 'error-row duration-300';
    },
    ...mapActions([
      "fetchAllCategories",
      "fetchAllClassrooms",
      "fetchClassroomsFreeList",
      "fetchAllHots",
    ]),

    onPage(event) {
      this.query.page = event.page + 1;
      this.query.perPage = event.rows;
      this.fetchAllClassrooms(this.query);
    },
    debounceSearch(event) {
      this.search = event.target.value;
      this.query.page = 1;
      this.fetchAllClassrooms(this.query);
      // clearTimeout(this.debounce);
      // this.debounce = setTimeout(() => {
      // }, 1000);
    },
    formatDate(date) {
      return moment(date)
        .locale("id")
        .format("dddd, DD MMMM YYYY");
    },
  },
};
</script>
<style>
.active-row {
  background-color: #ECFDF5 !important;
}
.active-row:hover {
  background-color: #D1FAE5 !important;
}
.error-row {
  background-color: #FEF2F2 !important;
}
.error-row:hover {
  background-color: #FEE2E2 !important;
}
</style>
